import { render, staticRenderFns } from "./integralDetailTable.vue?vue&type=template&id=25275e8e&scoped=true"
import script from "./integralDetailTable.vue?vue&type=script&lang=js"
export * from "./integralDetailTable.vue?vue&type=script&lang=js"
import style0 from "./integralDetailTable.vue?vue&type=style&index=0&id=25275e8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25275e8e",
  null
  
)

export default component.exports